import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * ============================================================
 * LOGGED-IN USER KO YAHAN NAHI ROKNA
 * ============================================================
 *
 * ⚠️ YE BUG KYA THA:
 *
 * manifest.json mein start_url "/" hai - matlab Android app HAR
 * BAAR "/" se hi khulti hai. Aur "/" pe ye landing page tha, jo
 * ye dekhta hi nahi tha ki banda pehle se logged in hai.
 *
 * Natija: user login karta, app band karta, dobara kholta - aur
 * phir se "Continue as User / Poojari" wala page. Usse lagta ki
 * login udd gaya, jabki token localStorage mein safe pada tha.
 *
 * Isi wajah se 15-min access + 60-din refresh token ka poora
 * system bekaar lag raha tha - wo backend mein theek kaam kar
 * raha tha, par frontend use kar hi nahi raha tha.
 *
 * ⚠️ Laptop pe ye bug pakadna mushkil tha, kyunki wahan login ke
 * baad koi "/" pe wapas jaata hi nahi. Mobile app har baar wahin
 * se shuru hoti hai.
 *
 * ⚠️ localStorage seedha kyun padha, useAuth() se kyun nahi:
 * AuthContext bhi apni value localStorage se hi uthata hai, par
 * wo state pehle render ke baad settle hoti hai. Yahan faisla
 * pehle render se PEHLE chahiye, warna landing page ek jhalak
 * ke liye dikh jaayega phir gayab hoga - bura lagta hai.
 */
const LandingPage = () => {
	const navigate = useNavigate();

	// Jab tak ye tay na ho ki redirect karna hai ya nahi, kuch
	// mat dikhao. Warna landing page ek pal ko flash karega.
	const [checking, setChecking] = useState(true);

	useEffect(() => {
		const token = localStorage.getItem('token');
		const role = localStorage.getItem('role');

		if (token) {
			// replace: true - taaki back button dabane pe user
			// wapas is page pe na aa jaaye (loop ban jaata hai)
			if (role === 'POOJARI') {
				navigate('/poojari-dashboard', { replace: true });
			} else if (role === 'ADMIN' || role === 'SUPER_ADMIN') {
				navigate('/admin-dashboard', { replace: true });
			} else {
				navigate('/home', { replace: true });
			}
			return;
		}

		// Token nahi hai - normal landing page dikhao
		setChecking(false);
	}, [navigate]);

	if (checking) {
		return null;
	}

	const roleCards = [
		{
			title: 'Continue as User',
			subtitle: 'Book trusted Poojari for all religious ceremonies',
			icon: '👤',
			accent: 'user',
			path: '/login'
		},
		{
			title: 'Continue as Poojari',
			subtitle: 'Register yourself and receive more bookings',
			icon: '🙏',
			accent: 'poojari',
			path: '/poojari-login'
		}
	];

	return (
		<div className="premium-landing-shell">
			<div className="premium-mandala premium-mandala-left" />
			<div className="premium-mandala premium-mandala-right" />
			<div className="container py-4">
				<div className="premium-mobile-frame">
					<div className="text-center mb-4">
						<div className="premium-logo-badge">🕉️</div>
						<div className="premium-brand-pill">Yajman Pooja</div>
                        <h1 className="premium-title">Yajman Pooja</h1>
						<p className="premium-subtitle">Connecting Devotees &amp; Poojari</p>
					</div>
					<div className="premium-card-stack">
						{roleCards.map((card) => (
							<button
								key={card.title}
								type="button"
								className={`premium-role-card premium-role-card-${card.accent}`}
								onClick={() => navigate(card.path)}>
								<div className="premium-role-emoji">{card.icon}</div>
								<h2 className="premium-role-title">{card.title}</h2>
								<p className="premium-role-text">{card.subtitle}</p>
								<div className="premium-role-hint">Tap to continue</div>
							</button>
						))}
					</div>
					<div className="premium-trust-badge">
						<span>✨</span>
						Trusted divine booking experience for every ceremony
					</div>
				</div>
			</div>
		</div>
	);
};

export default LandingPage;